import { fetchClient } from "@/api/api";

/**
 * Everything `useFacets` needs to talk to one facets endpoint: how to key its
 * cache entries and how to fetch a given filter combination.
 */
export type FacetSource<TFacets> = {
	queryKey: (query: Record<string, unknown>) => string[];
	fetch: (query: Record<string, unknown>) => Promise<TFacets>;
};

export function createFacetSource<TFacets>(args: {
	path: string;
	queryKey: (payload?: { query: Record<string, unknown> }) => string[];
}): FacetSource<TFacets> {
	return {
		queryKey: (query) => args.queryKey({ query }),
		fetch: async (query) => {
			const { data, error } = await (fetchClient.GET as any)(args.path, {
				params: { query },
				throwOnError: true,
			});
			if (error) throw error;
			return data as TFacets;
		},
	};
}
